// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"470":"e739b09a","960":"9612103b"}[chunkId] + ".css";
};